import * as types from "./feedTypes";

const initialState = {
  posts: { items: [], total: 0, page: 1, limit: 20 },
  stories: [],
  loading: false,
  error: null,
};

export function feedReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_FEED_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_FEED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        posts: action.payload?.posts ?? state.posts,
        stories: action.payload?.stories ?? [],
      };
    case types.FETCH_FEED_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ?? "Failed to load feed",
      };
    case types.PREPEND_FEED_POST: {
      const post = action.payload;
      if (!post) return state;
      const items = [post, ...(state.posts?.items ?? [])];
      return {
        ...state,
        posts: {
          ...state.posts,
          items,
          total: (state.posts?.total ?? 0) + 1,
        },
      };
    }
    case types.PREPEND_FEED_STORY: {
      const story = action.payload;
      if (!story) return state;
      const stories = [story, ...(state.stories ?? [])];
      return { ...state, stories };
    }
    default:
      return state;
  }
}
